import React from 'react';
import ReactDOM from 'react-dom';

import HeroCarousel from '../../react/Carousels/Hero';

export default class {

	constructor(context) {
		this.context = context;
		this.init();
	}


	init() {
		this.initReact();
	}

	initReact() {
		ReactDOM.render(
			<HeroCarousel context={this.context}/>, this.context
		);
	}
}
